<template>
  <div class="flex flex-col gap-2 mt-10 mb-8">
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">
        {{
          $t("labels.generic", {
            pt: "Notas dos feedbacks",
            en: "Feedbacks",
          })
        }}
      </h4>

      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div class="bg-white rounded-lg border border-gray-300">
      <Table
        :slotData="feedbacks"
        :columns="columns"
        :loading="loader"
        :params="params"
        :filters="filters"
        :hasStatus="false"
        :hasActions="false"
        @onPaginate="paginate($event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { FeedbacksObjectiveStats } from "@/models/stats.model";
import { GoToRoute } from "@/utils/go-to.util";
import { delay, last, take } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { FeedbacksService } from "./feedbacks.service";
import { StatsRest } from "@/services/rest/stats.rest";
import saveAs from "file-saver";
import { feedbacksStats } from "./feedbacks.utils";

const Card = defineAsyncComponent(() => import("../../Card/card.vue"));
export default defineComponent({
  name: "feedbacksStats",
  components: { Card },
  emits: ["onGetCurrentObjective"],
  computed: {
    statsService(): FeedbacksService {
      return new FeedbacksService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    rest(): StatsRest {
      return new StatsRest();
    },
    classroomId(): string {
      return String(localStorage.getItem("objClassroomId"));
    },
  },
  watch: {
    $route(val) {
      if (this.$route.name === "statsObjective") {
        this.objectiveId = val.params.objectiveId;
        this.feedbacksPaginated();
      }
    },
  },
  data() {
    return {
      columns: feedbacksStats,
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      loader: true as boolean,
      btnLoading: false as boolean,
      objectiveId: "" as string,
      courseId: "" as string,
      params: new QueryParams(),
      feedbacks: [] as FeedbacksObjectiveStats,
    };
  },
  mounted() {
    this.courseId = String(this.$route.params.courseId);
    this.objectiveId = String(this.$route.params.objectiveId);
    this.feedbacksPaginated();
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      this.getFeedbacks(params);
    },
    feedbacksPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      this.getFeedbacks(params);
    },
    getFeedbacks(queryParams: QueryParams): void {
      this.statsService.feedbacks.pipe(take(2), last()).subscribe({
        next: (response: any) => {
          this.loader = false;
          this.feedbacks = response;
          this.params.total = response.total;
        },
        error: () => {
          this.loader = false;
        },
      });
      this.statsService.getFeedbacksByObjectiveStats(
        this.courseId,
        this.objectiveId,
        queryParams
      );
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getFeedbacksByObjectiveStatsCsv(this.courseId, this.objectiveId, {
          classroomId: this.classroomId,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `feedbacks_data.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
  },
});
</script>
